const INITIAL_STATE = { }

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CONFIRMATION_REQUEST":
      return { loading: true, ...state };
    case "CONFIRMATION_REQUEST_SUCCESS":
      return { loading: false, ...action.payload };
    default:
      return state;
  }
};